import {useSortableTable} from '@hm/fundamental'
import {useTranslation} from 'react-i18next'

import {StaticPartsTableData} from '../types'

export const useStaticPartsOverviewConfig = () => {
  const {t} = useTranslation()

  return useSortableTable<StaticPartsTableData>(
    [
      {
        id: 'name',
        label: t('staticParts.table.name')
      },
      {
        id: 'type',
        label: t('staticParts.table.equipmentType')
      },
      {
        id: 'description',
        label: t('staticParts.table.description')
      },
      {
        id: 'address',
        label: t('staticParts.table.address')
      },
      {
        id: 'actions',
        label: t('staticParts.table.actions'),
        sortable: false
      }
    ],
    [],
    {
      prefix: 'refra_static_parts_overview_table',
      postfixFieldName: 'cyPostfix'
    },
    {enableLocalSorting: true}
  )
}
